<template>
    <b-modal v-model="modal.show" hide-footer centered :title="(editing ? 'Editar' : 'Crear') + ' Área'">
        <b-form @submit.prevent="validateForm()" data-vv-scope="areas">
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label for="code">Código</label>
                        <el-input id="code" name="code" size="small" v-model="area.code" disabled data-vv-as=" "
                            v-validate="'required|min:3|max:10'" />
                        <div class="text-danger small" v-text="errors.first('areas.code')" />
                        <span class="text-success small float-right">
                            El código será generado automáticamente en el momento de la creación
                        </span>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <el-input id="name" name="name" size="small" v-model="area.name" data-vv-as=" "
                            v-validate="'required|min:3|max:255'" />
                        <div class="text-danger small" v-text="errors.first('areas.name')" />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="wor_area_id">Área Padre</label>
                        <el-select id="wor_area_id" name="wor_area_id" size="small" v-model="area.wor_area_id"
                            data-vv-as=" ">
                            <el-option v-for="area in areasFather" :key="area.id" :label="area.code + ' - ' + area.name"
                                :value="area.id" />
                        </el-select>
                        <div class="text-danger small" v-text="errors.first('areas.wor_area_id')" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <div class="w-100 text-center">
                    <hr />

                    <b-btn variant="primary" class="mx-1" size="sm" @click="validateForm()">
                        <i class="fa fa-save" /> Guardar
                    </b-btn>
                    <b-btn variant="secondary" class="mx-1" size="sm" @click="setModalShow(false)">
                        <i class="fa fa-close" /> Cancelar
                    </b-btn>
                </div>
            </b-row>
        </b-form>


    </b-modal>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('areas', [
            'area',
            'editing',
            'modal',
            'areasFather',
        ])
    },
    data() {
        return {
            company_id: this.$route.params.id,
        };
    },
    methods: {
        ...mapActions('areas', [
            'addArea',
            'updateArea',
            'fetchAreasTree',
        ]),
        ...mapMutations('areas', [
            'resetParams',
            'setModalShow'
        ]),
        async validateForm() {
            const result = await this.$validator.validateAll('areas');
            if (result) {
                if (this.editing) {
                    const res = await this.updateArea();
                    if (res) {
                        await this.fetchAreasTree(this.company_id);
                    }
                } else {
                    const res = await this.addArea();
                    if (res) {
                        await this.fetchAreasTree(this.company_id);
                    }
                }
            }
        }
    },
};
</script>

<style scoped></style>
